;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputText', inputText)

  /* @ngInject */
  function inputText () {
    return {
      restrict: 'EA',
      scope: {
        label: '@',
        description: '@',
        placeholder: '@',
        modelPropertyName: '@',
        model: '=',
        disabled: '<',
        readOnly: '<',
        mandatory: '<',
        change: '=',
        maxLength: '<',
        blur: '&',
        error: '=',
        copyIcon: '<',
        search: '<',
        onKeyDown: '&',
        onClear: '&'
      },
      templateUrl: '/core/directives/input-text/input-text-directive.html?$$REVISION$$',
      controller: 'InputTextController'
    }
  }
})()
